// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    priceListMobileList: [],
    selectedPriceListMobile: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'priceList',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setPriceListMobiles(state, action) {
            state.priceListMobileList = action.payload;
        },
        setSelectedPriceListMobile(state, action) {
            state.selectedPriceListMobile = action.payload;
        },
        setPriceListMobile(state, action) {
            const data = action.payload;
            const rowIndex = state.priceListMobileList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.priceListMobileList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedPriceListMobile } = slice.actions;
// ----------------------------------------------------------------------

export function getPriceListMobiles() {
    return async () => {
        try {
            const response = await axios.post('/price_list_mobile/list');
            if (response.data.status) {
                dispatch(slice.actions.setPriceListMobiles(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getPriceListMobile(id) {
    return async () => {
        try {
            const response = await axios.post('/price_list_mobile/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setPriceListMobile(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function savePriceListMobile(data) {
    return async function () {
        const response = await axios.post('price_list_mobile/save', data);
        return response;
    };
}

export function updatePriceListMobile(data) {
    return async function () {
        const response = await axios.post('price_list_mobile/update', data);
        return response;
    };
}

export function deletePriceListMobile(data) {
    return async function () {
        const response = await axios.post('price_list_mobile/delete', data);
        return response;
    };
}
